import React from 'react';
import VenueStorefrontContent from '../../../components/marketplace/VenueStorefrontContent';

const VenueMarketplaceHome = () => {
    return <VenueStorefrontContent />;
};

export default VenueMarketplaceHome;
